<template>
  <div class="container">
    <v-dialog
      max-width="500"
      v-model="addTriggerDialog">
      <AddTrigger
        v-if="addTriggerDialog"
        :channel_did="current_channel"
        :item="userEditObj"
        :context="itemtype || 'scene'"
        v-on:close="addTriggerDialog = false" />
    </v-dialog>
    <div class="body">
      <Triggers :item="userEditObj" />
      <div
        class="mt-2"
        style="
          display: flex;
          justify-content: space-between;
          align-content: end;
        ">
        <v-spacer />
        <v-btn
          class="mb-2"
          @click="addTriggerDialog = true"
          block
          variant="flat">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script setup>
import { deluge } from '../../../stores/deluge';
import { defineProps } from 'vue';
import AssetPreview from '../../Assets/AssetPreview.vue';
import Triggers from '../../Shared/Triggers.vue';
import AddTrigger from '../../Shared/AddTrigger.vue';
import { ref } from 'vue';
const addTriggerDialog = ref(false);
const props = defineProps(['userEditObj', 'current_channel', 'itemtype']);
</script>

<style scoped></style>
